export default "__VITE_ASSET__52404ada__"